"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/map"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));

var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactSwipeableViews = _interopRequireDefault(require("react-swipeable-views"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _cssConstants = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _Nugget = _interopRequireDefault(require("./Nugget.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../KESI2/KesiConstants");

var _QuizNugget = _interopRequireDefault(require("../../../../KESI2/entities/nuggets/QuizNugget"));

var _index = _interopRequireDefault(require("../../Button/index"));

var _DrupalQuizNugget = _interopRequireDefault(require("./DrupalQuizNugget.scss"));

var _index2 = require("../../../../KESI2/Services/RemoteControlService/index");

var _FeatureManager = _interopRequireDefault(require("../../../../utils/features/FeatureManager"));

var _KESI2Helper = _interopRequireWildcard(require("../../../../KESI2/KESI2Helper"));

var _Spinner = _interopRequireDefault(require("../../Spinner/Spinner"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _DrupalQuizNuggetStrings = require("./DrupalQuizNuggetStrings");

var _MuiAlertHelper = require("../../../../helpers/MuiAlertHelper");

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _FeedbackService = require("../../../../KESI2/Services/FeedbackService");

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

var _CssHelper = _interopRequireDefault(require("../../../../helpers/CssHelper"));

var _PreconditionChecker = require("../../../../utils/PreconditionChecker");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'quizContainer_';
var QUESTION_TYPES = {
  SINGLE_CHOICE: 1
};

var DrupalQuizNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalQuizNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalQuizNugget);

  function DrupalQuizNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalQuizNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "removeDataStoreData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var fullPath, kesiUpdateValue;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fullPath = "".concat(_config["default"].targetSpecificDataStorePath, ".").concat(_this.props.id); // await DataStore.removeData(fullPath)

              _context.next = 3;
              return _DataStore["default"].setSingleData(fullPath, {});

            case 3:
              kesiUpdateValue = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE) || 0;
              _context.next = 6;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, kesiUpdateValue + 1);

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "checkEnterKey", function (event) {
      if (event.key === 'Enter') {
        var nugget = _this.state.content[_this.props.id];
        var el = document.activeElement;

        if (el) {
          if (el.id.indexOf('quizCheck_') > -1) {
            var indexParts = el.id.split('_');

            if (indexParts.length > 3) {
              var questionId = indexParts[1];
              var answerId = indexParts[2];
              var answerIndex = (0, _parseInt2["default"])(indexParts[3]);
              var question = nugget.questions.find(function (q) {
                return q.id === questionId;
              });

              if (question) {
                var answer = question.answers.find(function (a) {
                  return a.id === answerId;
                });
                var givenAnswers = _this.state.chosenMcAnswers;
                var storedIndex = givenAnswers.findIndex(function (elem) {
                  return elem.index === answerIndex + 1;
                });

                if (storedIndex >= 0) {
                  givenAnswers.splice(storedIndex, 1);

                  _this.setState({
                    chosenMcAnswers: givenAnswers
                  }, _this.forceUpdate());
                } else if (givenAnswers.length < nugget.maxNumberOfAnswers || !nugget.maxNumberOfAnswers) {
                  givenAnswers.push({
                    answer: answer,
                    index: answerIndex + 1
                  });

                  _this.setState({
                    renderFeedback: false,
                    chosenMcAnswers: givenAnswers
                  }, _this.forceUpdate());
                }
              }
            }
          } else if (el.id.indexOf('quizRadio_') > -1) {
            var _indexParts = el.id.split('_');

            if (_indexParts.length > 2) {
              var _questionId = _indexParts[1];
              var _answerId = _indexParts[2];

              var _question = nugget.questions.find(function (q) {
                return q.id === _questionId;
              });

              console.log('checkEnterKey question', _question);

              if (_question) {
                var _answer = _question.answers.find(function (a) {
                  return a.id === _answerId;
                });

                console.log('checkEnterKey answer', _answer);

                if (_this.state.renderFeedback) {
                  _this.setState({
                    renderFeedback: false
                  }, _this.forceUpdate());
                }

                _this.setState({
                  chosenAnswer: _answer
                }, _this.forceUpdate());
              }
            }
          }
        }
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getQuestionLengthWithPreconditionsChecked", function () {
      var questions = _this.getQuestionsWithPreconditionsChecked();

      return questions.length;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getQuestionsWithPreconditionsChecked", function () {
      var nugget = _this.state.content[_this.props.id];
      var questions = nugget.questions;
      var questionsToReturn = [];
      questions.forEach(function (question) {
        var precondition = question.showPrecondition;

        if (precondition) {
          var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(precondition);

          if (!failingPrecondition) {
            questionsToReturn.push(question);
          }
        } else {
          questionsToReturn.push(question);
        }
      });
      return questionsToReturn;
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "goToNextQuestion", function () {
      var nugget = _this.state.content[_this.props.id];
      var currentIndex = _this.state.questionIndex;

      var length = _this.getQuestionLengthWithPreconditionsChecked();

      if (currentIndex + 1 >= length && (_this.state.questionCorrect || nugget.allowFalseAnswers)) {
        _this.onLastQuestionAnswered(nugget);

        if (!_config["default"].showInfoAfterLastQuizQuestion) {
          return;
        }
      } // if (!this.props.inSwipeContainer) {
      //   this.props.scrollToNugget(this.props.id)
      // }


      var questions = _this.getQuestionsWithPreconditionsChecked();

      _this.setState({
        chosenAnswer: null,
        chosenMcAnswers: [],
        questionFeedback: null,
        questionIndex: currentIndex + 1,
        questionCorrect: false,
        currentQuestion: questions[currentIndex + 1]
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "onLastQuestionAnswered", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(nugget) {
        var state;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = {
                  questionFeedback: null
                };

                if (nugget.allowFalseAnswers) {
                  state.quizFinished = true;
                }

                _this.setState(state);

                if (!nugget.datastore) {
                  _context2.next = 12;
                  break;
                }

                _context2.prev = 4;
                _context2.next = 7;
                return _DataStore["default"].setDataBulk(nugget.datastore, true, true);

              case 7:
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](4);
                console.error('error parsing nugget.datastore:', _context2.t0);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 9]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "sortQuestions", function () {
      return _this.getQuestionsWithPreconditionsChecked();
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "selectMCAnswer", function (storedIndex, answers, answer, index, evt) {
      if (evt && (evt.key !== ' ' || evt.key !== 'Enter')) {
        return;
      }

      var nugget = _this.state.content[_this.props.id];

      if (storedIndex >= 0) {
        answers.splice(storedIndex, 1);

        _this.setState({
          chosenMcAnswers: answers
        }, _this.forceUpdate());
      } else if (answers.length < nugget.maxNumberOfAnswers || !nugget.maxNumberOfAnswers) {
        answers.push({
          answer: answer,
          index: index + 1
        });

        _this.setState({
          renderFeedback: false,
          chosenMcAnswers: answers
        }, _this.forceUpdate());
      }
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderMC", function (question, answers) {
      var nugget = _this.state.content[_this.props.id];
      return answers.map(function (answer, index) {
        if (!answer) {
          return null;
        }

        var labelStyle = {
          width: '80%',
          marginLeft: '8px'
        };

        if (nugget.displayInline) {
          labelStyle = {
            textAlign: 'center',
            paddingTop: '50px',
            width: '100%',
            paddingLeft: 0
          };
        }

        if (_this.props.isInTutorial || _this.props.inWizardContainer) {
          labelStyle = {
            width: '100%'
          };
        }

        var answers = _this.state.chosenMcAnswers;
        var storedIndex = answers.findIndex(function (elem) {
          return elem.index === index + 1;
        });
        return /*#__PURE__*/_react["default"].createElement("li", {
          key: "".concat(question.id, "_").concat(answer.id),
          "aria-label": answer.text,
          style: nugget.displayInline ? {
            display: 'inline-block',
            width: "".concat(100 / answers.length, "%")
          } : {
            width: '100%'
          }
        }, /*#__PURE__*/_react["default"].createElement("input", {
          tabIndex: -1,
          id: "".concat(question.id, "_").concat(answer.id),
          key: "".concat(question.id, "_").concat(answer.id),
          name: question.id,
          type: "checkbox",
          checked: storedIndex > -1,
          disabled: _this.state.quizFinished,
          onClick: function onClick() {
            _this.selectMCAnswer(storedIndex, answers, answer, index);
          },
          style: nugget.displayInline ? {
            left: '50%',
            transform: 'translateX(-50%)'
          } : {}
        }), /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: "".concat(question.id, "_").concat(answer.id),
          dangerouslySetInnerHTML: {
            __html: answer.text
          },
          style: labelStyle
        }), /*#__PURE__*/_react["default"].createElement("div", {
          title: answer.text,
          tabIndex: 0,
          onKeyDown: function onKeyDown(evt) {
            _this.selectMCAnswer(storedIndex, answers, answer, index, evt);
          },
          id: "quizCheck_".concat(question.id, "_").concat(answer.id, "_").concat(index),
          className: nugget.displayInline ? 'checkInline' : 'check'
        }));
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "selectSCAnswer", function (answer, evt) {
      if (evt && (evt.key !== ' ' || evt.key !== 'Enter')) {
        return;
      }

      if (_this.state.renderFeedback) {
        _this.setState({
          renderFeedback: false
        });
      }

      _this.setState({
        chosenAnswer: answer
      });
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "replaceHrefs", function (htmlStr) {
      var newStr = htmlStr.replace(/<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1/g, function (match, p1, p2) {
        // do not replace mailto links etc
        if (match.indexOf('http') !== -1) {
          return "<a href=\"javascript:;\" onclick=\"window.open('".concat(p2, "', '_system')\"");
        }

        return match;
      });
      return newStr;
    });
    _this.state = _objectSpread({
      questionFeedback: null,
      questionIndex: 0,
      chosenAnswer: null,
      chosenMcAnswers: [],
      currentQuestion: null,
      questionCorrect: false,
      quizFinished: false,
      waitingForActivation: false,
      correctAnswers: 0,
      questionCount: 0,
      doneQuestions: []
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;
    _this.alreadyChangingQuestions = false;

    _this.props.registerNugget(_this.props.id, _QuizNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalQuizNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES, _DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, "".concat(_config["default"].targetSpecificDataStorePath, ".").concat(_this.props.id)]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalQuizNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.registerNuggetPosition(this.props.id, _QuizNugget["default"].CLASS, this.getDomId());
      var nugget = this.state.content[this.props.id];

      var read = _KESI2Helper["default"].checkIfContentIsMarkedAsReadInStore(nugget);

      var questions = this.sortQuestions();

      if (nugget.markAllOptionsOnStart && !read) {
        var answersToSet = [];
        questions.forEach(function (question) {
          question.answers.forEach(function (answer, index) {
            answersToSet.push({
              answer: answer,
              index: index + 1
            });
          });
        });
        this.setState({
          chosenMcAnswers: answersToSet
        });
      }

      if (nugget.showPreviousResultsOnReopen && read) {
        var _answersToSet = [];
        questions.forEach(function (question) {
          question.answers.forEach(function (answer, index) {
            if (answer.datastore && _DataStore["default"].pathExists(answer.datastore) && _DataStore["default"].getElementByPathImmediately(answer.datastore) === true) {
              _answersToSet.push({
                answer: answer,
                index: index + 1
              });
            }
          });
        });
        this.setState({
          chosenMcAnswers: _answersToSet
        });
      }

      this.setState({
        currentQuestion: questions[0]
      });

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }

      if (this.props.forcedUIColor) {
        if (_config["default"].useTileBackgroundColorInTile) {
          _CssHelper["default"].addCssRule('.epr .quiz ul li .radio', "{border: 2px solid ".concat(this.props.forcedUIColor, " !important}"));

          _CssHelper["default"].addCssRule('.epr .quiz input[type="radio"]:checked ~ .radio::before, .epr .quiz input[type="checkbox"]:checked ~ .check::before, .epr .voting input[type="radio"]:checked ~ .radio::before, .epr .voting input[type="checkbox"]:checked ~ .check::before, .epr .voting input[type="radio"]:checked ~ .radioInline::before, .epr .voting input[type="checkbox"]:checked ~ .checkInline::before', "{background: ".concat(this.props.forcedUIColor, " !important}"));
        }
      }

      if (this.props.inWizardContainer) {
        var hasMandatoryQuestions = questions.filter(function (question) {
          return question.isMandatory;
        }).length > 0;
        this.props.setStepDone(!hasMandatoryQuestions);
      }

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.addEventListener('keypress', function (event) {
          return _this2.checkEnterKey(event);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;

      if (_DeviceInfoHelper["default"].isBrowser()) {
        window.removeEventListener('keypress', function (event) {
          return _this3.checkEnterKey(event);
        });
      } // this.removeDataStoreData()


      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalQuizNugget.prototype), "componentWillUnmount", this).call(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalQuizNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join('!')), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join('!')] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }

      if (this.props.inWizardContainer && nugget.isMandatory) {
        var isDone = this.state.chosenMcAnswers.length > 0 || !!this.state.chosenAnswer;
        this.props.setStepDone(isDone);
      }
    }
  }, {
    key: "checkQuestionType",
    value: function checkQuestionType(answers) {
      var count = 0;
      answers.forEach(function (answer) {
        if (answer.correct) {
          count++;
        }
      });
      return count;
    }
  }, {
    key: "checkAnswer",
    value: function () {
      var _checkAnswer = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(questionType, caller) {
        var _this4 = this;

        var nugget, currentIndex, sortedQuestions, currentQuestion, questionLength, logObject, question, okButton, correctAnswers, fullPath, _correctAnswers, questionCount, state, doneQuestions, isCurrentDone, _okButton, _okButton2, answersToCheck, givenAnswers, _correctAnswers2, correctTexts, feedback, feedbackToShow, questionCorrect, _fullPath, quizData, _correctAnswers3, _questionCount, correctAnswersFeedback, _okButton3;

        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                nugget = this.state.content[this.props.id];
                currentIndex = this.state.questionIndex;
                sortedQuestions = this.sortQuestions();
                currentQuestion = sortedQuestions[currentIndex];
                questionLength = this.getQuestionLengthWithPreconditionsChecked();
                logObject = {};

                if (_config["default"].logDrupalQuizAnswersToDataStore) {
                  question = sortedQuestions[this.state.questionIndex];
                  logObject.id = "".concat(this.props.id, "-").concat(this.state.questionIndex);
                  logObject.question = question.question;
                  logObject.title = question.title;
                }

                if (!(questionType === QUESTION_TYPES.SINGLE_CHOICE)) {
                  _context5.next = 36;
                  break;
                }

                if (this.state.chosenAnswer) {
                  _context5.next = 12;
                  break;
                }

                okButton = {
                  forcedColor: this.props.forcedUIColor,
                  label: 'OK'
                };
                (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalQuizNuggetStrings.getString)('NO_OPTION_CHOSEN'), (0, _DrupalQuizNuggetStrings.getString)('NO_OPTION_CHOSEN_TITLE'), true, okButton);
                return _context5.abrupt("return");

              case 12:
                if (_config["default"].logDrupalQuizAnswersToDataStore) {
                  logObject.chosenAnswers = [this.state.chosenAnswer.text];

                  _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.KESI_QUESTION_LOG, ".").concat(logObject.id), logObject);
                }

                this.setState({
                  questionCount: this.state.questionCount + 1
                });

                if (this.state.chosenAnswer.correct) {
                  correctAnswers = this.state.correctAnswers + 1;
                  this.setState({
                    correctAnswers: correctAnswers
                  });
                }

                if (!this.state.chosenAnswer.datastore) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 18;
                return _DataStore["default"].setDataBulk(this.state.chosenAnswer.datastore, true, true);

              case 18:
                if (!(_config["default"].targetSpecificDataStorePath && currentIndex + 1 === questionLength)) {
                  _context5.next = 25;
                  break;
                }

                fullPath = "".concat(_config["default"].targetSpecificDataStorePath, ".").concat(this.props.id);
                _correctAnswers = this.state.correctAnswers;
                questionCount = questionLength;
                console.log('target.targetSpecificDataStorePath true', fullPath, _correctAnswers, questionCount);
                _context5.next = 25;
                return _DataStore["default"].setSingleData(fullPath, {
                  correctQuizAnswers: _correctAnswers,
                  questionCount: questionCount
                });

              case 25:
                if (!(nugget.hideFeedbacks || !this.state.chosenAnswer.feedback && _config["default"].showOnlyDrupalQuestionFeedback)) {
                  _context5.next = 28;
                  break;
                }

                this.goToNextQuestion();
                return _context5.abrupt("return");

              case 28:
                state = {
                  questionFeedback: this.state.chosenAnswer.feedback
                };

                if (nugget.allowFalseAnswers) {
                  if (!this.props.inSwipeContainer) {
                    this.props.markAsRead(this.props.id);
                  }
                }

                if (this.state.chosenAnswer.correct) {
                  state.questionCorrect = true;

                  if (currentIndex === questionLength - 1 && !nugget.allowFalseAnswers) {
                    if (!this.props.inSwipeContainer) {
                      this.props.markAsRead(this.props.id);
                    }
                  }

                  if (!_config["default"].showInfoAfterLastQuizQuestion && currentIndex + 1 === questionLength) {
                    state.quizFinished = true;
                  } else if (_config["default"].showInfoAfterLastQuizQuestion && currentIndex + 1 === questionLength + 1) {
                    state.quizFinished = true;
                  }
                }

                this.setState(state);

                if (this.state.currentQuestion.isMandatory) {
                  doneQuestions = (0, _toConsumableArray2["default"])(this.state.doneQuestions);
                  isCurrentDone = this.state.chosenMcAnswers.length > 0 || !!this.state.chosenAnswer;

                  if (isCurrentDone) {
                    this.setState({
                      doneQuestions: (0, _toConsumableArray2["default"])(new _map["default"](doneQuestions.push(this.state.currentQuestion.id)))
                    });
                  } else {
                    this.setState({
                      doneQuestions: doneQuestions.filter(function (question) {
                        return question.id !== _this4.state.currentQuestion.id;
                      })
                    });
                  }
                }

                if (_config["default"].useAlertsForQuizNugget) {
                  _okButton = {
                    callback: function callback() {
                      console.log('button callback', state.questionCorrect || nugget.allowFalseAnswers);
                      state.questionCorrect || nugget.allowFalseAnswers ? _this4.goToNextQuestion() : function () {};
                    },
                    forcedColor: this.props.forcedUIColor,
                    label: state.questionCorrect || nugget.allowFalseAnswers ? 'OK' : (0, _DrupalQuizNuggetStrings.getString)('MC_TRY_AGAIN'),
                    theme: 'big'
                  };
                  (0, _MuiAlertHelper.showAlertWithOptions)({
                    message: this.state.chosenAnswer.feedback,
                    title: _config["default"].showOnlyDrupalQuestionFeedback ? '\n\n\n' : state.questionCorrect ? (0, _DrupalQuizNuggetStrings.getString)('CORRECT_KESI') : (0, _DrupalQuizNuggetStrings.getString)('NOT_CORRECT_KESI'),
                    showCloseButton: false,
                    buttons: [_okButton],
                    size: 'large',
                    style: {
                      color: 'black !important',
                      textAlign: 'left !important'
                    },
                    centeredContent: false
                  });
                }

                _context5.next = 71;
                break;

              case 36:
                // multiple choice
                if (_config["default"].logDrupalQuizAnswersToDataStore) {
                  logObject.chosenAnswers = this.state.chosenMcAnswers.map(function (answer) {
                    return answer.answer ? answer.answer.text : null;
                  });

                  _DataStore["default"].setSingleData("".concat(_DataStore.DATA_STORE_PATHS.KESI_QUESTION_LOG, ".").concat(logObject.id), logObject);
                }

                if (!(this.state.chosenMcAnswers.length === 0)) {
                  _context5.next = 41;
                  break;
                }

                _okButton2 = {
                  forcedColor: this.props.forcedUIColor,
                  label: 'OK'
                };
                (0, _MuiAlertHelper.showWideAlertHtml)((0, _DrupalQuizNuggetStrings.getString)('NO_OPTION_CHOSEN'), (0, _DrupalQuizNuggetStrings.getString)('NO_OPTION_CHOSEN_TITLE'), true, _okButton2);
                return _context5.abrupt("return");

              case 41:
                answersToCheck = this.state.chosenMcAnswers;

                if (_config["default"].sortMCFeedback) {
                  answersToCheck = this.state.chosenMcAnswers.sort(function (a, b) {
                    if (a.index < b.index) {
                      return -1;
                    } else if (a.index > b.index) {
                      return 1;
                    }

                    return 0;
                  });
                }

                if (!(nugget.hideFeedbacks || !answersToCheck.find(function (answer) {
                  return Boolean(answer.answer.feedback);
                }) && _config["default"].showOnlyDrupalQuestionFeedback)) {
                  _context5.next = 48;
                  break;
                }

                _context5.next = 46;
                return _promise["default"].all(this.state.currentQuestion.answers.map( /*#__PURE__*/function () {
                  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(option) {
                    var storedIndex;
                    return _regenerator["default"].wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            storedIndex = answersToCheck.findIndex(function (elem) {
                              return elem.answer.id === option.id;
                            });

                            if (option.datastore) {
                              if (storedIndex > -1) {
                                _DataStore["default"].setDataBulk(option.datastore, true);
                              }
                            }

                            return _context3.abrupt("return", _promise["default"].resolve());

                          case 3:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4) {
                    return _ref3.apply(this, arguments);
                  };
                }()));

              case 46:
                this.goToNextQuestion();
                return _context5.abrupt("return");

              case 48:
                givenAnswers = answersToCheck;
                _correctAnswers2 = 0;
                correctTexts = '';
                feedback = '';

                if (_config["default"].sortMCQuizAnswers) {
                  givenAnswers.sort(function (answer1, answer2) {
                    if (answer1.index < answer2.index) {
                      return -1;
                    }

                    if (answer1.index > answer2.index) {
                      return 1;
                    }

                    return 0;
                  });
                }

                givenAnswers.forEach(function (answer) {
                  if (answer.answer.correct) {
                    _correctAnswers2++;
                    feedback += _config["default"].showOnlyDrupalQuestionFeedback ? (0, _DrupalQuizNuggetStrings.getString)('MC_CORRECT_ANSWER_DRUPAL_ONLY', [answer.index, answer.answer.feedback]) : (0, _DrupalQuizNuggetStrings.getString)('MC_CORRECT_ANSWER', [answer.index, answer.answer.feedback]);
                  } else {
                    feedback += _config["default"].showOnlyDrupalQuestionFeedback ? (0, _DrupalQuizNuggetStrings.getString)('MC_WRONG_ANSWER_DRUPAL_ONLY', [answer.index, answer.answer.feedback]) : (0, _DrupalQuizNuggetStrings.getString)('MC_WRONG_ANSWER', [answer.index, answer.answer.feedback]);
                  }
                });
                currentQuestion.answers.forEach(function (answer, index) {
                  if (answer && answer.correct === true) {
                    if (correctTexts.length === 0) {
                      correctTexts = "<b>\"".concat(answer.text, "\"</b>");
                    } else {
                      correctTexts += ", <br /><br /><b>\"".concat(answer.text, "\"</b>");
                    }
                  }
                });
                feedbackToShow = null;
                questionCorrect = _correctAnswers2 === answersToCheck.length && questionType === answersToCheck.length;

                if (!_config["default"].targetSpecificDataStorePath) {
                  _context5.next = 64;
                  break;
                }

                _fullPath = "".concat(_config["default"].targetSpecificDataStorePath, ".").concat(this.props.id);
                quizData = _DataStore["default"].getElementByPathImmediately(_fullPath) || 0;
                _correctAnswers3 = quizData.correctQuizAnswers ? quizData.correctQuizAnswers : 0;
                _questionCount = quizData.correctQuizAnswers ? quizData.questionCount : 0;
                _context5.next = 64;
                return _DataStore["default"].setSingleData(_fullPath, {
                  correctQuizAnswers: questionCorrect ? _correctAnswers3 + 1 : _correctAnswers3,
                  questionCount: _questionCount + 1
                }, false);

              case 64:
                correctAnswersFeedback = '<br /><br />Die richtigen Antworten wären gewesen:<br /><br />' + correctTexts.concat(' ') + '.';

                if (questionCorrect) {
                  feedbackToShow = _config["default"].showOnlyDrupalQuestionFeedback ? feedback : (0, _DrupalQuizNuggetStrings.getString)('MC_ALL_CORRECT', [feedback]);
                  this.setState({
                    questionCorrect: true,
                    questionFeedback: _config["default"].showOnlyDrupalQuestionFeedback ? feedback : (0, _DrupalQuizNuggetStrings.getString)('MC_ALL_CORRECT', [feedback])
                  });

                  if (currentIndex + 1 === questionLength) {
                    this.setState({
                      quizFinished: true
                    });
                    this.props.markAsRead(this.props.id);
                  }
                } else if (answersToCheck.length < questionType) {
                  feedbackToShow = _config["default"].showOnlyDrupalQuestionFeedback ? feedback : (0, _DrupalQuizNuggetStrings.getString)('MC_NOT_ENOUGH_CHOSEN', [feedback + correctAnswersFeedback]);
                  this.setState({
                    questionFeedback: feedbackToShow
                  });
                } else if (_correctAnswers2 === 0 && answersToCheck.length === questionType) {
                  feedbackToShow = _config["default"].showOnlyDrupalQuestionFeedback ? feedback : (0, _DrupalQuizNuggetStrings.getString)('MC_ALL_WRONG', [feedback + correctAnswersFeedback]);
                  this.setState({
                    questionFeedback: feedbackToShow
                  });
                } else if (_correctAnswers2 > 0 && answersToCheck.length === questionType && _correctAnswers2 !== questionType) {
                  feedbackToShow = _config["default"].showOnlyDrupalQuestionFeedback ? feedback : (0, _DrupalQuizNuggetStrings.getString)('MC_NOT_ALL_RIGHT', [feedback + correctAnswersFeedback]);
                  this.setState({
                    questionFeedback: feedbackToShow
                  });
                } else if (answersToCheck.length > questionType) {
                  feedbackToShow = _config["default"].showOnlyDrupalQuestionFeedback ? feedback : (0, _DrupalQuizNuggetStrings.getString)('MC_TOO_MUCH_CHOSEN', [feedback + correctAnswersFeedback]);
                  this.setState({
                    questionFeedback: feedbackToShow
                  });
                }

                if (!questionCorrect) {
                  _context5.next = 69;
                  break;
                }

                _context5.next = 69;
                return _promise["default"].all(this.state.currentQuestion.answers.map( /*#__PURE__*/function () {
                  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(option) {
                    var storedIndex;
                    return _regenerator["default"].wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            storedIndex = answersToCheck.findIndex(function (elem) {
                              return elem.answer.id === option.id;
                            });

                            if (option.datastore) {
                              if (storedIndex > -1) {
                                _DataStore["default"].setDataBulk(option.datastore, true);
                              }
                            }

                            return _context4.abrupt("return", _promise["default"].resolve());

                          case 3:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x5) {
                    return _ref4.apply(this, arguments);
                  };
                }()));

              case 69:
                if (nugget.allowFalseAnswers) {
                  this.props.markAsRead(this.props.id);
                }

                if (_config["default"].useAlertsForQuizNugget) {
                  _okButton3 = {
                    callback: questionCorrect || nugget.allowFalseAnswers ? function () {
                      return _this4.goToNextQuestion();
                    } : function () {},
                    forcedColor: this.props.forcedUIColor,
                    label: questionCorrect ? 'OK' : nugget.allowFalseAnswers ? 'OK' : (0, _DrupalQuizNuggetStrings.getString)('MC_TRY_AGAIN'),
                    theme: 'big'
                  };
                  (0, _MuiAlertHelper.showAlertWithOptions)({
                    html: feedbackToShow,
                    title: _config["default"].showOnlyDrupalQuestionFeedback ? '\n\n\n' : questionCorrect ? (0, _DrupalQuizNuggetStrings.getString)('CORRECT_KESI') : (0, _DrupalQuizNuggetStrings.getString)('NOT_CORRECT_KESI'),
                    showCloseButton: false,
                    buttons: [_okButton3],
                    size: 'large',
                    style: {
                      color: 'black !important',
                      textAlign: 'left !important'
                    },
                    centeredContent: false
                  });
                }

              case 71:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function checkAnswer(_x2, _x3) {
        return _checkAnswer.apply(this, arguments);
      }

      return checkAnswer;
    }()
  }, {
    key: "renderQuestion",
    value: function renderQuestion() {
      var _this5 = this;

      var nugget = this.state.content[this.props.id];
      var sortedQuestions = this.sortQuestions();
      var questionLength = this.getQuestionLengthWithPreconditionsChecked();

      if (!sortedQuestions || questionLength === 0) {
        return null;
      } // noinspection UnnecessaryLocalVariableJS (reason: better to read)


      var questions = sortedQuestions.map(function (question, index) {
        if (index <= _this5.state.questionIndex - 1 || index >= _this5.state.questionIndex + 1) {
          // null is not allowed in swipeable views so return an empty div
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: question.id
          });
        }

        var answers = question.answers;

        var questionType = _this5.checkQuestionType(answers);

        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_DrupalQuizNugget["default"].quiz, " quiz"),
          key: question.id,
          style: {
            opacity: _this5.state.questionIndex === index ? 1 : 0,
            transition: 'opacity 200ms 200ms'
          }
        }, questionLength > 1 ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalQuizNugget["default"].quizInfo
        }, (0, _DrupalQuizNuggetStrings.getString)('QUESTION_NUMBER', [_this5.state.questionIndex + 1, questionLength])) : null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _this5.props.inSwipeContainer || _this5.props.inGalleryContainer ? 'titleSmall' : 'title',
          dangerouslySetInnerHTML: {
            __html: question.question
          }
        }), question.info && /*#__PURE__*/_react["default"].createElement("div", {
          className: "info ".concat(_Nugget["default"].info),
          dangerouslySetInnerHTML: {
            __html: question.info
          }
        }), /*#__PURE__*/_react["default"].createElement("ul", {
          className: _DrupalQuizNugget["default"].answerList
        }, questionType === 1 && answers.map(function (answer) {
          if (!answer) {
            return null;
          }

          return /*#__PURE__*/_react["default"].createElement("li", {
            key: "".concat(question.id, "_").concat(answer.id),
            style: nugget.displayInline ? {
              display: 'inline-block',
              width: "".concat(100 / answers.length, "%")
            } : {}
          }, /*#__PURE__*/_react["default"].createElement("input", {
            tabIndex: -1,
            id: "".concat(question.id, "_").concat(answer.id),
            key: "".concat(question.id, "_").concat(answer.id),
            "aria-label": answer.text,
            name: question.id,
            type: "radio",
            disabled: _this5.state.quizFinished,
            checked: _this5.state.chosenAnswer && _this5.state.chosenAnswer.id === answer.id,
            onClick: function onClick() {
              _this5.selectSCAnswer(answer);
            },
            style: nugget.displayInline ? {
              left: '50%',
              transform: 'translateX(-50%)'
            } : {}
          }), /*#__PURE__*/_react["default"].createElement("label", {
            htmlFor: "".concat(question.id, "_").concat(answer.id),
            style: nugget.displayInline ? {
              textAlign: 'center',
              paddingTop: '50px',
              width: '100%',
              paddingLeft: 0
            } : {
              width: '100%'
            }
          }, answer.text), /*#__PURE__*/_react["default"].createElement("div", {
            tabIndex: 0,
            onKeyDown: function onKeyDown(evt) {
              _this5.selectSCAnswer(answer, evt);
            },
            id: "quizRadio_".concat(question.id, "_").concat(answer.id),
            className: nugget.displayInline ? 'radioInline' : 'radio'
          }));
        }), questionType > 1 && _this5.renderMC(question, answers)), !_this5.state.quizFinished && !nugget.hideCheckAnswerButton ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _DrupalQuizNugget["default"].buttonContainer
        }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
          id: "checkAnswerBtn_".concat(questionType, "_").concat(index),
          tabIndex: 0,
          forcedColor: _this5.props.forcedUIColor,
          className: _config["default"].useCenteredButtons ? _DrupalQuizNugget["default"].centeredButton : '',
          onClick: function onClick() {
            return _this5.checkAnswer(questionType, 'button');
          }
        }, (0, _DrupalQuizNuggetStrings.getString)('CHECK_ANSWER'))) : null);
      });
      return questions;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;

      /**
       * @type {QuizNugget}
       */
      var nugget = this.state.content[this.props.id];
      var active = _DataStore["default"].pathExists("".concat(_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, ".").concat(this.props.id, ".").concat(this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER))) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] || nugget.active : nugget.active;
      var innerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].innerHidden) : '';
      var outerClassNames = !active && !(0, _KESI2Helper.isKesiMaster)() ? "".concat(_Nugget["default"].outerHidden) : '';
      var likes = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_LIKES) || [];
      var likeIndex = likes.indexOf(this.props.id);
      var allLikes = this.state.data[_DataStore.DATA_STORE_PATHS.KESI_ALL_LIKES];
      var currentLikesForId = allLikes && allLikes["".concat(this.props.id)] ? allLikes["".concat(this.props.id)] : 0;

      var isAuthor = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SHOW_UNPUBLISHED_CONTENT);

      var replacedInfo = nugget.info ? this.replaceHrefs(nugget.info) : null;
      console.log('quiznugget', nugget);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "quizContainer ".concat(_DeviceInfoHelper["default"].isBrowser() ? '' : 'mobile', " ").concat(this.getDomId(), " ").concat(_Nugget["default"].outerContainer, " ").concat(outerClassNames),
        id: "".concat(this.getDomId()),
        style: this.props.inSwipeContainer || this.props.inListContainer || this.props.inGalleryContainer ? {
          width: '100%',
          padding: 0,
          margin: 0
        } : {}
      }, _config["default"].showNuggetIcons ? this.props.renderIcon(nugget) : null, /*#__PURE__*/_react["default"].createElement("div", {
        id: "quizContainer",
        className: "QuizNugget_".concat(this.props.id, " ").concat(nugget.theme, " quizarea ").concat(_Nugget["default"].container, " ").concat(innerClassNames)
      }, isAuthor && !nugget.isPublished && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          padding: '10px',
          color: 'red'
        }
      }, "Content unver\xF6ffentlicht"), nugget.showTitle ? /*#__PURE__*/_react["default"].createElement("div", {
        className: this.props.inGalleryContainer ? 'titleSmall' : 'title'
      }, nugget.title) : null, nugget.info && /*#__PURE__*/_react["default"].createElement("div", {
        className: "info ".concat(_Nugget["default"].info),
        dangerouslySetInnerHTML: {
          __html: replacedInfo
        }
      }), /*#__PURE__*/_react["default"].createElement(_reactSwipeableViews["default"], {
        disabled: true,
        slideStyle: {
          overflow: 'hidden'
        },
        index: this.state.questionIndex
      }, this.renderQuestion(), _config["default"].showInfoAfterLastQuizQuestion ? /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          width: '100%',
          height: '300px',
          position: 'relative'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: '25px'
        }
      }, "Vielen Dank f\xFCr Ihre Teilnahme!")) : null), !_config["default"].useAlertsForQuizNugget && this.state.questionFeedback ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalQuizNugget["default"].overlay
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _config["default"].showNuggetDivider ? _DrupalQuizNugget["default"].window : _DrupalQuizNugget["default"].windowNoBorder,
        style: {
          transform: 'translate(-50%, -50%)'
        }
      }, !_config["default"].showOnlyDrupalQuestionFeedback && /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.questionCorrect ? "".concat(_DrupalQuizNugget["default"].feedback, " correct") : "".concat(_DrupalQuizNugget["default"].feedback, " wrong")
      }, this.state.questionCorrect ? (0, _DrupalQuizNuggetStrings.getString)('CORRECT_KESI') : (0, _DrupalQuizNuggetStrings.getString)('NOT_CORRECT_KESI')), /*#__PURE__*/_react["default"].createElement("div", {
        className: _DrupalQuizNugget["default"].feedbackText,
        dangerouslySetInnerHTML: {
          __html: this.state.questionFeedback
        }
      }), /*#__PURE__*/_react["default"].createElement(_index["default"], {
        forcedColor: this.props.forcedUIColor,
        onClick: this.state.questionCorrect || nugget.allowFalseAnswers ? function () {
          return _this6.goToNextQuestion();
        } : function () {
          _this6.setState({
            questionFeedback: null
          });
        }
      }, this.state.questionCorrect || nugget.allowFalseAnswers ? 'OK' : (0, _DrupalQuizNuggetStrings.getString)('MC_TRY_AGAIN')))) : null), _config["default"].hasLikeFunctionalityForNuggets && !this.props.inSwipeContainer && !this.props.inListContainer && !this.props.inGalleryContainer ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeContainer
      }, _config["default"].useTargetIcons ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _Nugget["default"].svgLikeButton,
        onClick: function onClick() {
          return _this6.props.setLike();
        },
        src: likeIndex < 0 ? _config["default"].likeInactive : _config["default"].likeActive
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        onClick: function onClick() {
          return _this6.props.setLike();
        },
        className: likeIndex < 0 ? _Nugget["default"].likeButton : _Nugget["default"].likeButtonActivated,
        name: 'thumbs-o-up'
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _Nugget["default"].likeText
      }, "".concat(currentLikesForId, " ").concat(currentLikesForId === 1 ? 'Like' : 'Likes'))) : null);
    }
  }]);
  return DrupalQuizNugget;
}(_KESI2BasicComponent["default"]);

exports["default"] = DrupalQuizNugget;
DrupalQuizNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inWizardContainer: _propTypes["default"].bool,
  isInTutorial: _propTypes["default"].bool,
  setStepDone: _propTypes["default"].func,
  scrollToNugget: _propTypes["default"].func,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  goUpFunc: _propTypes["default"].func,
  forcedUIColor: _propTypes["default"].string,
  renderIcon: _propTypes["default"].func.isRequired,
  setLike: _propTypes["default"].func
};
DrupalQuizNugget.defaultProps = {
  id: null
};